class r {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return !!a.match(/^(LT-)?\s?([0-9]{5})$/i);
  }
}
export {
  r as default
};
